import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import { useParams } from 'react-router-dom'
import { Container, Row, Col, Pagination } from "react-bootstrap";
import PageHeader from '../../components/pageHeader/pageHeader.component';
import CollegeCategoryCard from '../../components/collegeCategoryCard/collegeCategoryCard.component';

import MedicalCollegesPageCover from '../../assets/images/banners/medical-colleges.png';
import ArmedForcesMedicalCover from '../../assets/images/colleges/armed-force.jpg';
import DhakaMedicalCover from '../../assets/images/colleges/dmc.jpg';
import DentalMedicalCover from '../../assets/images/colleges/dental-college.jpg';

import './medicalColleges.module.css';

const MedicalCollegesPage = props => {

    const { loading, collegeCategory } = useSelector(state => state.all)

    let active = 2;
    let items = [
        <Pagination.First>First</Pagination.First>,
        <Pagination.Prev>Prev</Pagination.Prev>
    ];
    for (let number = 1; number <= 5; number++) {
        items.push(
            <Pagination.Item key={number} active={number === active}>
                {number}
            </Pagination.Item>,
        );
    }
    items.push(<Pagination.Next>Next</Pagination.Next>);
    items.push(<Pagination.Last>Last</Pagination.Last>);

    return (
        <div>
            <PageHeader
                title="মেডিকেল কলেজসমূহ"
                cover={MedicalCollegesPageCover}
            >
                <p>
                    কঠিন বিষয়গুলো সহজে মনে রাখা জন্য Tricks শেখানো হয়। একইসাথে অধিক গুরুত্বপূর্ণ অংশগুলো চিহ্নিত করতে লাল
                    সবুজ কালিতে বই দাগানো হয়ে থাকে।
                </p>
            </PageHeader>

            <section className="py-5" styleName="medical-college-section">
                <Container>
                    {loading ? <Loading /> : (
                        <Row>
                            {collegeCategory && collegeCategory.map(item => (
                                <Col key="college_1" className="mb-4" xs={12} lg={4}>
                                    <CollegeCategoryCard
                                        link={`/medical-colleges/${item.name.replace(/ /g, "-")}/${item._id}`}
                                        image={`${bucket_url}${item.coverPhoto}`}
                                        title={item.name}
                                    />
                                </Col>
                            ))}

                        </Row>
                    )}

                </Container>
            </section>

            {/* <section className="admission-section">
                <Container>
                    <Row>
                        <Col>

                        </Col>
                    </Row>
                </Container>
            </section> */}
        </div>
    )
}

export default MedicalCollegesPage;